// Page contact. WhatsApp Business d'abord, e-mail ensuite — aucun
// formulaire depuis le 26/09/2026 : il envoyait sur Telegram, et une
// personne bloquée à l'installation répond plus vite dans une conversation
// que dans un aller-retour de formulaire.
import { Link } from 'react-router-dom'
import LegalShell from '../components/urself/LegalShell'
import { COMPANY } from '../lib/legal'
import { whatsappLink } from '../lib/support'
import { useT } from '../lib/i18n'

export default function Contact () {
  const t = useT()
  const L = t.legal.contact

  return (
    <LegalShell
      title={L.title}
      intro={L.intro(t.legal.supportDelay, t.legal.supportHours)}
    >
      <div className="u-chan">
        <a className="u-chan__c" href={whatsappLink(L.waMsg)} target="_blank" rel="noopener noreferrer">
          <span className="u-chan__n">WhatsApp</span>
          <span className="u-chan__v">{L.openChat}</span>
          <span className="u-chan__s">{L.whatsappS}</span>
        </a>

        <a className="u-chan__c" href={`mailto:${COMPANY.email}`}>
          <span className="u-chan__n">{L.emailN}</span>
          <span className="u-chan__v">{COMPANY.email}</span>
          <span className="u-chan__s">{L.emailS}</span>
        </a>
      </div>

      <h2>{L.fastT}</h2>
      <p>{L.fastP(COMPANY.refundDays)}</p>

      <h2>{L.cantT}</h2>
      <p>{L.cantP1(COMPANY.removalDelayHours)}</p>
      <p>{L.cantP2}</p>

      <h2>{L.betT(t.legal.betAmount)}</h2>
      <p>
        {L.betP1}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
        {L.betP2}
        <Link to="/remboursement">{L.betLink}</Link>.
      </p>

      <h2>{L.gdprT}</h2>
      <p>{L.gdprP}</p>
    </LegalShell>
  )
}
